import { baseTitle } from "../config";

export const addLeadingZero = (number) => {
  if (parseInt(number) < 10) {
    return `0${number}`;
  }

  return number;
};

export const setDocTitle = (title = "", vueThis) => {
  document.title = `${baseTitle.replace(
    "{{company}}",
    vueThis.$store.state.company
  )}${title !== "" ? ` - ${title}` : ""}`;
};

export const map = (value, x1, y1, x2, y2) =>
  ((value - x1) * (y2 - x2)) / (y1 - x1) + x2;

const gcd = (a, b) => {
  return b == 0 ? a : gcd(b, a % b);
};

export const ratio = (w, h) => {
  const r = gcd(w, h);
  return {
    width: w / r,
    height: h / r,
  };
};

export const clamp = (num, min, max) => Math.min(Math.max(num, min), max);

export const getFilenameAndExtension = (pathfilename) => {
  var filenameextension = pathfilename.replace(/^.*[\\/]/, "");
  var filename = filenameextension.substring(
    0,
    filenameextension.lastIndexOf(".")
  );
  var ext = filenameextension.split(".").pop();

  return [filename, ext];
};

export const getUrlExtension = (url) => {
  if (typeof url === "object") {
    //is blob
    return url.type.split("/").pop().trim();
  }

  return url.split(/[#?]/)[0].split(".").pop().trim();
};
